import Settings from "./Settings";
import { useAuthContext } from "../../AuthProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket, faTrash } from "@fortawesome/free-solid-svg-icons";

const NavBarButtom = () => {
  const { logout } = useAuthContext();
  return (
    <ul className="menu  w-full rounded-lg text-sm p-2 text-white">
      {/* <Settings /> */}
      <li>
        <a className="hover:bg-red-500" onClick={() => logout()}>
          <FontAwesomeIcon icon={faRightFromBracket} />
          Log out
        </a>
      </li>
    </ul>
  );
};

export default NavBarButtom;
